import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {
  openPreviewModal: React.Dispatch<React.SetStateAction<boolean>>
}

const DisplayImageAction = ({ openPreviewModal }: Props) => {
  const showPreview = () => openPreviewModal(true)

  return <Button type="secondary" onClick={showPreview} iconName="arrow-right" />
}

export default observer(DisplayImageAction)
